import * as s from './DropdownArrow.scss';

export const DropdownArrow = (className: string = '') => {
  return `<span aria-hidden="true" class="${s.arrowIcon} ${className}">▼</span>`;
};
